module.exports = __webpack_public_path__ + "img/92d7eddb1cb6bf63c201b509f12ffe43.265084f0.png";